import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@node-space/ui-components'
import { ConfirmationOfPayeeCalloutType, ConfirmationOfPayeeCalloutTypes } from '../types'

const CTA_TEXT_MAPPING: Record<ConfirmationOfPayeeCalloutType, string> = {
  [ConfirmationOfPayeeCalloutTypes.BENEFICIARY_PAYOUT]:
    'wallets.fiatSend.verificationOfPayee.updateThisBeneficiary',
  [ConfirmationOfPayeeCalloutTypes.BANK_ACCOUNT_PAYOUT]:
    'wallets.fiatSend.verificationOfPayee.updateThisBankAccount',
  [ConfirmationOfPayeeCalloutTypes.BENEFICIARY]: 'manageBeneficiaries.reviewBeneficiaryDetails',
  [ConfirmationOfPayeeCalloutTypes.BANK_ACCOUNT]: 'manageBeneficiaries.reviewBankAccountDetails',
}

interface ConfirmationOfPayeeCalloutCtaProps {
  type: ConfirmationOfPayeeCalloutType
  handleEditBeneficiary?: () => void
}

export const ConfirmationOfPayeeCalloutCta = ({
  type,
  handleEditBeneficiary,
}: ConfirmationOfPayeeCalloutCtaProps) => {
  const { t } = useTranslation()

  if (!type || !handleEditBeneficiary) return

  const textKey = CTA_TEXT_MAPPING[type]

  if (!textKey) return

  return (
    <Button variant="ghost" noPadding onClick={handleEditBeneficiary}>
      {t(textKey)}
    </Button>
  )
}
